import { ApiResponse, HomePageDataResponse } from "../Models";

export const homePageDataResponseMockup: ApiResponse<HomePageDataResponse> = {
  statusCode: 200,
  error: null,
  data: {
    crops: [
      {
        code: "1",
      },
      {
        code: "2",
      },
      {
        code: "3",
      },
      {
        code: "4",
      },
      {
        code: "5",
      },
      {
        code: "6",
      },
      {
        code: "7",
      },
      {
        code: "8",
      },
      {
        code: "9",
      },
      {
        code: "10",
      },
      {
        code: "11",
      },
      {
        code: "12",
      },
      {
        code: "13",
      },
      {
        code: "14",
      },
      {
        code: "15",
      },
      {
        code: "16",
      },
      {
        code: "17",
      },
      {
        code: "18",
      },
      {
        code: "19",
      },
      {
        code: "20",
      },
      {
        code: "21",
      },
      {
        code: "22",
      },
      {
        code: "23",
      },
      {
        code: "24",
      },
      {
        code: "25",
      },
      {
        code: "26",
      },
      {
        code: "27",
      },
      {
        code: "28",
      },
      {
        code: "29",
      },
      {
        code: "30",
      },
      {
        code: "31",
      },
      {
        code: "32",
      },
      {
        code: "33",
      },
      {
        code: "34",
      },
      {
        code: "35",
      },
      {
        code: "36",
      },
      {
        code: "37",
      },
      {
        code: "38",
      },
      {
        code: "39",
      },
      {
        code: "40",
      },
      {
        code: "41",
      },
      {
        code: "42",
      },
      {
        code: "43",
      },
      {
        code: "44",
      },
      {
        code: "45",
      },
      {
        code: "46",
      },
      {
        code: "47",
      },
      {
        code: "48",
      },
      {
        code: "49",
      },
      {
        code: "50",
      },
      {
        code: "51",
      },
      {
        code: "52",
      },
      {
        code: "53",
      },
      {
        code: "54",
      },
      {
        code: "55",
      },
      {
        code: "56",
      },
      {
        code: "57",
      },
      {
        code: "58",
      },
      {
        code: "59",
      },
      {
        code: "60",
      },
      {
        code: "61",
      },
      {
        code: "62",
      },
      {
        code: "63",
      },
      {
        code: "64",
      },
      {
        code: "65",
      },
      {
        code: "66",
      },
      {
        code: "67",
      },
      {
        code: "68",
      },
      {
        code: "69",
      },
      {
        code: "70",
      },
      {
        code: "71",
      },
      {
        code: "72",
      },
      {
        code: "73",
      },
      {
        code: "74",
      },
    ],
    metricMethods: [
      {
        code: "1",
      },
      {
        code: "2",
      },
    ],
    countriesWithHaifaProducts: [
      {
        code: "AL",
      },
      {
        code: "AR",
      },
      {
        code: "AM",
      },
      {
        code: "AU",
      },
      {
        code: "AT",
      },
      {
        code: "AZ",
      },
      {
        code: "BE",
      },
      {
        code: "BZ",
      },
      {
        code: "BA",
      },
      {
        code: "BR",
      },
      {
        code: "BG",
      },
      {
        code: "KH",
      },
      {
        code: "CA",
      },
      {
        code: "CN",
      },
      {
        code: "CO",
      },
      {
        code: "CR",
      },
      {
        code: "HR",
      },
      {
        code: "CY",
      },
      {
        code: "CZ",
      },
      {
        code: "DK",
      },
      {
        code: "EC",
      },
      {
        code: "EE",
      },
      {
        code: "ET",
      },
      {
        code: "FI",
      },
      {
        code: "FR",
      },
      {
        code: "PF",
      },
      {
        code: "GE",
      },
      {
        code: "DE",
      },
      {
        code: "GH",
      },
      {
        code: "GR",
      },
      {
        code: "GT",
      },
      {
        code: "HN",
      },
      {
        code: "HK",
      },
      {
        code: "HU",
      },
      {
        code: "IS",
      },
      {
        code: "IN",
      },
      {
        code: "IE",
      },
      {
        code: "IL",
      },
      {
        code: "IT",
      },
      {
        code: "CI",
      },
      {
        code: "JP",
      },
      {
        code: "JO",
      },
      {
        code: "KZ",
      },
      {
        code: "KE",
      },
      {
        code: "LA",
      },
      {
        code: "LV",
      },
      {
        code: "LT",
      },
      {
        code: "MK",
      },
      {
        code: "MT",
      },
      {
        code: "MQ",
      },
      {
        code: "MU",
      },
      {
        code: "MX",
      },
      {
        code: "MD",
      },
      {
        code: "ME",
      },
      {
        code: "MM",
      },
      {
        code: "NA",
      },
      {
        code: "NL",
      },
      {
        code: "NI",
      },
      {
        code: "NG",
      },
      {
        code: "NO",
      },
      {
        code: "PA",
      },
      {
        code: "PY",
      },
      {
        code: "PE",
      },
      {
        code: "PH",
      },
      {
        code: "PL",
      },
      {
        code: "PT",
      },
      {
        code: "PR",
      },
      {
        code: "RO",
      },
      {
        code: "RU",
      },
      {
        code: "RW",
      },
      {
        code: "SN",
      },
      {
        code: "RS",
      },
      {
        code: "SG",
      },
      {
        code: "SK",
      },
      {
        code: "SI",
      },
      {
        code: "ZA",
      },
      {
        code: "KR",
      },
      {
        code: "ES",
      },
      {
        code: "SE",
      },
      {
        code: "CH",
      },
      {
        code: "TW",
      },
      {
        code: "TZ",
      },
      {
        code: "TH",
      },
      {
        code: "TT",
      },
      {
        code: "TR",
      },
      {
        code: "UG",
      },
      {
        code: "UA",
      },
      {
        code: "GB",
      },
      {
        code: "US",
      },
      {
        code: "UY",
      },
      {
        code: "UZ",
      },
      {
        code: "VN",
      },
      {
        code: "ZM",
      },
      {
        code: "Iberia",
      },
      {
        code: "South America",
      },
    ],
    ourProducts: [
      {
        name: "HaifaStim™ Booster",
        descriptionKey: "HaifaStimBooster",
        image: "",
        link: "",
      },
      {
        name: "HaifaStim™ Wall-Up",
        descriptionKey: "HaifaStimWallUp",
        image: "",
        link: "",
      },
      {
        name: "Haifa Bonus",
        descriptionKey: "HaifaBonus",
        image: "",
        link: "",
      },
    ],
    multicoteNutrientsTypes: ["PK", "P2O5 K2O"],
  },
};
